<!-- <button type="button" class="btn btn-primary mt-4" (click)="finalize()">Finalize</button> -->
<div class="p-3">
    <div class="d-flex justify-content-between my-4 mx-3">
              <div class="row">
        <h5>Freeze SOTR - <span class="text-primary">   [{{payload?.proposal_name}}]</span></h5>
         <h6><span class="text-primary"> [
                    {{
                    stepDetails?.step_status == 0
                    ? 'INITIATION PENDING'
                    : (stepDetails?.step_status | uppercase)
                    }}
                    ]</span></h6>
                    </div>
        <div class="d-flex gap-2">
            <!-- <p-button pTooltip="Generate PDF" icon="pi pi-file-pdf" (onClick)="generatePDF()" [outlined]="true"></p-button> -->
            <!-- <p-button pTooltip="Edit Form" icon="pi pi-pencil" (onClick)="editForm()" [outlined]="true"></p-button> -->
              <!-- <p-button label="Freeze" icon="pi pi-save" (onClick)="freeze()" [outlined]="true"></p-button> -->
                 <p-button label="Next" icon="pi pi-angle-right" iconPos="right" (onClick)="goToNextStep()"
                [outlined]="true" *ngIf="stepDetails?.step_status == 'approved'"></p-button>
            <p-button label="Freeze" icon="pi pi-save" (onClick)="freeze()" [outlined]="true" *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)"></p-button>
            <p-button label="Initiate" icon="pi pi-play" *ngIf="stepDetails?.is_initiator" (onClick)="IRA.emit('Initiate')" [outlined]="true"></p-button>
            <p-button label="Approve" icon="pi pi-check-circle" *ngIf="stepDetails?.is_approver" (onClick)="IRA.emit('Approve')" [outlined]="true"></p-button>
            <p-button label="Recommend" icon="pi pi-thumbs-up" *ngIf="stepDetails?.is_recommender" (onClick)="IRA.emit('Recommend')" [outlined]="true"></p-button>
    
        </div>
    </div>
    <hr>



<div class="card mb-5">
<table class="custom-table w-100">
  <thead>
    <tr>
      <th class="wid-30-percent"></th>
      <th>Version Name</th>
      <th>Status</th>
      <th>Document</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let product of freezeSotrData">
      <td>
        <input
          type="radio"
          name="selectedProduct"
          [value]="product"
          [(ngModel)]="selectedProduct"
        />
      </td>
      <td>{{ product.name }}</td>
      <td>
        <span
          [ngClass]="{
            'tag-info': product.sotr_status === 1,
            'tag-success': product.sotr_status !== 1
          }"
        >
          {{ product.sotr_status === 1 ? 'Under Review' : 'Finalized' }}
        </span>
      </td>
      <td>
        <a href="#" (click)="openPrintWindow(product.paragraph)">View</a>
      </td>
    </tr>
  </tbody>
</table>

</div>
</div>